import React from 'react';

/**
 * Card used by the authentication screens (login, verification, recovery...).
 */
const AuthCard = ({ icon = 'fa-user', title, subtitle, onBack, children }) => (
    <div className="psp-auth-card psp-fade-in">
        {onBack && (
            <button type="button" className="psp-auth-card__back" onClick={onBack} aria-label="Voltar">
                <i className="fas fa-arrow-left" aria-hidden="true" />
            </button>
        )}
        <div className="psp-auth-card__header">
            <div className="psp-auth-card__icon">
                <i className={`fas ${icon}`} aria-hidden="true" />
            </div>
            <h1 className="psp-auth-card__title">{title}</h1>
            {subtitle && <p className="psp-auth-card__subtitle">{subtitle}</p>}
        </div>
        {children}
    </div>
);

export default AuthCard;
